import { useAppContext } from '../context/AppContext';
import { forgotPassword } from '../services';
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import darkLogo from '../assets/dark-logo.png';
import lightLogo from '../assets/light-logo.png';

export const ForgotPasswordPage = ({ darkMode }) => {
  const { base_url, token, showStatus } = useAppContext();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (token) {
      navigate('/', { replace: true });
    }
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      showStatus('error', 'Please enter your email address.');
      return;
    }

    setLoading(true);
    try {
      const data = await forgotPassword(email.trim(), base_url);
      setSubmitted(true);
      showStatus(
        'success',
        data.msg || 'If an account exists for that email, we have sent password reset instructions.',
      );
    } catch (error) {
      showStatus('error', error.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img
              src={darkMode ? darkLogo : lightLogo}
              alt=""
              width={48}
              height={48}
              decoding="async"
            />
          </div>
          <h1>Slipstream</h1>
          <p>{submitted ? 'Check your email' : 'Reset your password'}</p>
        </div>

        {submitted ? (
          <div className="login-success">
            <p>
              If an account exists for that email, we have sent password reset instructions.
              The link expires in 1 hour.
            </p>
            <Link to="/login" className="btn btn-primary login-submit">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label className="form-label" htmlFor="forgot-email">Email</label>
              <input
                id="forgot-email"
                className="form-input"
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
                autoFocus
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary login-submit"
              disabled={loading}
            >
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}

        {!submitted && (
          <p className="login-footer-link">
            <Link to="/login">Back to sign in</Link>
          </p>
        )}
      </div>
    </div>
  );
};
